<template>
    <div>
        <waterfall :line-gap="50" :watch="eggs" :grow="realGrow()" interval="200">
            <!-- each component is wrapped by a waterfall slot -->
            <waterfall-slot
                v-for="(item, index) in eggs"
                :width="200"
                :height="266"
                :order="index"
                :key="item.id"
                :id="`egg${index}`"
            >
            <v-hover>
                <template v-slot:default="{ hover }">
                <v-card :elevation="hover ? 24 : 2" class="custom-card pa-lg-1 ma-lg-1">
                    <v-img :src="imageSource(item.name)"
                        @click="showEgg(item)"
                        lazy-src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                        ></v-img>
                </v-card>
                </template>
            </v-hover>

            </waterfall-slot>

        </waterfall>

        <v-dialog
            v-model="dialog"
            width="500"
            @click:outside="closeDialog()"
            >

            <v-card
                max-width="500"
            >

                <v-img
                    lazy-src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    height="250"
                    style="border: 3px solid #fff;"
                    :src="imageSource(selectedImage.name)"
                ></v-img>

                <v-card-title>
                    <v-icon class="mr-1" color="rgba(0,0,0,0.8)">
                        mdi-egg-fried
                    </v-icon>
                    Your Daily Egg
                </v-card-title>

                <v-card-text>
                    <v-row
                        align="center"
                        class="mx-0"
                    >
                        <v-rating
                            :value="parseFloat(rating)"
                            color="amber"
                            dense
                            half-increments
                            readonly
                            size="14"
                        ></v-rating>

                        <div class="grey--text ms-4">
                            {{ rating }}
                        </div>
                    </v-row>

                    <div class="my-4 text-subtitle-1">
                    
                    </div>

                    <div>
                        <span class="mr-2" v-for="(item, index) in selectedImage.desc.split(', ')" :key="index">
                            <v-chip
                                class="ma-1"
                                :color="sortBy === item ? 'success' : 'orange'"
                                label
                                outlined
                                @click="filterClose(item)"
                                >
                                {{ item }}
                            </v-chip>
                        </span>
                    </div>
                </v-card-text>

                <v-divider class="mx-4"></v-divider>

                <v-card-title style="justify-content:space-between">
                    <div class="body-2 grey--text text--lighten-1">
                        <v-icon class="mr-1" small color="grey lighten-1" style="vertical-align:middle">mdi-calendar</v-icon>
                        {{ selectedImage.date }}
                    </div>

                    <div>
                        <v-icon class="mr-2" color="error">mdi-heart</v-icon>
                        yUM yUM
                        <v-icon class="ml-2" color="error">mdi-heart</v-icon>
                    </div>
                </v-card-title>
            </v-card>
        </v-dialog>

    </div>

</template>

<script>
    import Waterfall from 'vue-waterfall/lib/waterfall'
    import WaterfallSlot from 'vue-waterfall/lib/waterfall-slot'
    import { mapState, mapActions } from 'vuex'

  export default {
    name: 'HelloWorld',

    data: () => ({
        grow: [0.82, 1.43, 1.01, 0.92, 1.33, 1.21],
        dialog: false,
        selectedImage: {id: 0, name: null, desc: ''},
        rating: 4.5,
    }),

    components: {
      Waterfall,
      WaterfallSlot,
    },

    computed: {
      ...mapState({
          eggs: 'items',
          sortBy: 'sortBy'
      }),

      ingredients: function() {
            const ingred = []
            for (let item of this.eggs) {
                const comps = item.desc.split(', ');
                for (let comp of comps) {
                    if (!ingred.includes(comp)) {
                        ingred.push(comp)
                    }
                }
            }
            return ingred
      },
    },

    methods: {
        ...mapActions({
            shuffle: 'shuffle',
            filter: 'filter',
        }),

        imageSource(name) {
            let src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
            if (name) {
                src = require(`@/assets/eggs/${name}`)
            }

            return src
        },

        showEgg(item) {
            this.rating = (Math.random() * (5 - 3.5) + 3.5).toFixed(1)
            this.selectedImage = item
            this.dialog = true
        },

        closeDialog()  {
            this.dialog = false
        },

        filterClose(item) {
            this.filter(item)
            this.dialog = false
        },

        realGrow() {
            let realGrow = this.grow
            if (window.innerWidth <= 800) {
                realGrow = this.grow.slice(0, 4)
            }

            return realGrow
        }
    },
  }
</script>

<style lang="sass">
    @import '~vuetify/src/components/VCard/_variables.scss'

    @media #{map-get($display-breakpoints, 'md-and-down')}
        .custom-card
            border-radius: 0 !important
</style>